import { InvoiceViewOptions } from "@common/types/invoice";
import {
    useWorkspaceUserCache,
    WORKSPACE_USER_CACHE_KEYS,
} from "../useWorkspaceUserCache";

export function useInvoicesPageViewOptionsCache(): [
    InvoiceViewOptions | undefined,
    (value: InvoiceViewOptions | undefined) => void,
] {
    const [value, setter] = useWorkspaceUserCache<InvoiceViewOptions>(
        WORKSPACE_USER_CACHE_KEYS.INVOICES_PAGE_VIEW_OPTIONS_CACHE_KEY,
    );

    return [
        value,
        (viewOptions: InvoiceViewOptions | undefined) => {
            setter(viewOptions);
        },
    ];
}
